"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Logo = _interopRequireDefault(require("../../../IconicDisplayElements/Logo"));

var _PageHeaderText = _interopRequireDefault(require("../../../TextElements/BasicTextElements/PageHeaderText"));

var _AuthorizedMenuMobile = require("./AuthorizedMenuMobile.styles");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Menu/Header component.  Handles desktop and mobile renderings. Expects MenuItemsWrapper as children.
 */
var AuthorizedMenuMobile = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AuthorizedMenuMobile, _React$PureComponent);

  var _super = _createSuper(AuthorizedMenuMobile);

  function AuthorizedMenuMobile() {
    var _this;

    _classCallCheck(this, AuthorizedMenuMobile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "logoOnClickHandler", function () {
      return _this.props.logoOnClick();
    });

    return _this;
  }

  _createClass(AuthorizedMenuMobile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          inverse = _this$props.inverse,
          logo = _this$props.logo,
          title = _this$props.title;
      return /*#__PURE__*/_react.default.createElement(_AuthorizedMenuMobile.StyledMenuMobile, {
        className: className,
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-menu-mobile"
      }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
        className: "c-menu-mobile-logo-wrapper",
        dataTestId: "menu-mobile-logo",
        inverse: inverse,
        image: logo || null,
        mobile: true,
        onClick: this.logoOnClickHandler
      }), title && /*#__PURE__*/_react.default.createElement("div", {
        className: "c-menu-mobile-title"
      }, /*#__PURE__*/_react.default.createElement(_PageHeaderText.default, {
        className: "c-title-text",
        colorTheme: "overDark",
        dataTestId: "menu-title"
      }, title)), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-menu-mobile-user-button"
      }, children)));
    }
  }]);

  return AuthorizedMenuMobile;
}(_react.default.PureComponent);

_defineProperty(AuthorizedMenuMobile, "propTypes", {
  /** Children are expected to be MenuItemsWrapper objects - That's 'MenuItemsWrapper', plural.
   * Additionally, childKeys are expected to be provided by the children and should be either 'loggedInItems' or 'loggedOutItems' */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Determine logo color */
  inverse: _propTypes.default.bool,

  /** alternate logo uri */
  logo: _propTypes.default.string,

  /** onClick function for the logo */
  logoOnClick: _propTypes.default.func
});

_defineProperty(AuthorizedMenuMobile, "defaultProps", {
  children: undefined,
  className: '',
  logo: null,
  logoOnClick: function logoOnClick() {}
});

var _default = AuthorizedMenuMobile;
exports.default = _default;